
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.667 1.667H5V5H1.667V1.667zm0 4.666H5v3.334H1.667V6.333zM5 11H1.667v3.333H5V11zm1.333-9.333h3.334V5H6.333V1.667zm3.334 4.666H6.333v3.334h3.334V6.333zM6.333 11h3.334v3.333H6.333V11zm8-9.333H11V5h3.333V1.667zM11 6.333h3.333v3.334H11V6.333zM14.333 11H11v3.333h3.333V11z","fill":"#2A333D"}})])
          )
        }
      }
    